import { Loader2 } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

/**
 * CancelSubscriptionModal — extraído de Dashboard.jsx en P3.1 sesión 2/4 (feb-2026).
 *
 * Modal de confirmación de cancelación de suscripción Premium. JSX y clases
 * Tailwind IDÉNTICOS al original.
 *
 * Reglas del cuadro negro:
 * - NO ejecuta nada por sí mismo, solo dispara los handlers recibidos.
 * - Mantiene los mismos data-testid.
 */
const CancelSubscriptionModal = ({ open, isSubActionLoading, onConfirm, onClose }) => {
  const { language } = useLanguage();

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[10001] flex items-center justify-center bg-black/70 backdrop-blur-sm p-4"
      onClick={() => isSubActionLoading !== 'cancel' && onClose()}
      data-testid="premium-banner-cancel-modal"
    >
      <div
        className="bg-zinc-900 border border-zinc-700 rounded-xl p-6 max-w-sm w-full shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <h3
          className="text-base font-semibold text-white mb-2"
          data-testid="premium-banner-cancel-modal-title"
        >
          {language === 'es'
            ? '¿Cancelar tu suscripción Premium?'
            : 'Cancel your Premium subscription?'}
        </h3>
        <p className="text-sm text-zinc-400 mb-5">
          {language === 'es'
            ? 'Seguirás teniendo acceso hasta el final del período ya pagado.'
            : 'You will still have access until the end of your current billing period.'}
        </p>
        <div className="flex justify-end gap-2">
          <button
            onClick={onClose}
            disabled={isSubActionLoading === 'cancel'}
            className="px-4 py-2 text-sm text-zinc-300 hover:text-white hover:bg-zinc-800 rounded-lg transition-colors"
            data-testid="premium-banner-cancel-modal-keep"
          >
            {language === 'es' ? 'No, mantener' : 'No, keep it'}
          </button>
          <button
            onClick={onConfirm}
            disabled={isSubActionLoading === 'cancel'}
            className="px-4 py-2 text-sm text-white bg-red-600 hover:bg-red-500 rounded-lg transition-colors flex items-center gap-2 disabled:opacity-60"
            data-testid="premium-banner-cancel-modal-confirm"
          >
            {isSubActionLoading === 'cancel' && <Loader2 className="w-4 h-4 animate-spin" />}
            {language === 'es' ? 'Confirmar cancelación' : 'Confirm cancellation'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelSubscriptionModal;
